var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3638 5.26514C30.5969 5.26514 27.2538 6.75201 24.9888 9.30764C22.7238 6.75201 19.3806 5.26514 15.6138 5.26514C12.3329 5.26911 9.18761 6.57417 6.86771 8.89407C4.5478 11.214 3.24274 14.3593 3.23877 17.6401C3.23877 31.2039 23.0781 42.0414 23.9219 42.497C24.2498 42.6736 24.6164 42.766 24.9888 42.766C25.3612 42.766 25.7278 42.6736 26.0556 42.497C26.8994 42.0414 46.7388 31.2039 46.7388 17.6401C46.7348 14.3593 45.4297 11.214 43.1098 8.89407C40.7899 6.57417 37.6446 5.26911 34.3638 5.26514ZM33.3344 31.9576C30.723 34.1736 27.9315 36.168 24.9888 37.9201C22.0461 36.168 19.2545 34.1736 16.6431 31.9576C12.58 28.472 7.73877 23.1564 7.73877 17.6401C7.73877 15.5516 8.56845 13.5485 10.0453 12.0717C11.5222 10.5948 13.5252 9.76514 15.6138 9.76514C18.9513 9.76514 21.745 11.5276 22.9056 14.3664C23.0746 14.7802 23.3629 15.1343 23.7339 15.3836C24.1049 15.6329 24.5418 15.766 24.9888 15.766C25.4357 15.766 25.8726 15.6329 26.2436 15.3836C26.6146 15.1343 26.903 14.7802 27.0719 14.3664C28.2325 11.5276 31.0263 9.76514 34.3638 9.76514C36.4524 9.76514 38.4554 10.5948 39.9322 12.0717C41.4091 13.5485 42.2388 15.5516 42.2388 17.6401C42.2388 23.1564 37.3975 28.472 33.3344 31.9576Z",
    fill: "url(#paint0_linear_1660_62)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_62",
    x1: 24.9888,
    y1: 5.26514,
    x2: 24.9888,
    y2: 42.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.5d614cbd05572c5c6e22b68c16dca1f6.svg";
export { ForwardRef as ReactComponent };